/**
 * Helper class used to generate IDs unique to the current session
 */
export class UniqueIdGenerator {
    /**
     * Gets a unique (relatively to the current session) Id
     */
    static get UniqueId() {
        const result = this._NextUniqueId;
        this._NextUniqueId++;
        return result;
    }
    /**
     * Ensures future generated IDs are greater than the specified value
     * @param minimum - The minimum value that future generated IDs should be greater than
     */
    static EnsureIdsGreaterThan(minimum) {
        if (this._NextUniqueId <= minimum) {
            this._NextUniqueId = minimum + 1;
        }
    }
}
/**
 * The next unique ID to be returned
 */
UniqueIdGenerator._NextUniqueId = 1;
//# sourceMappingURL=uniqueIdGenerator.js.map